import { ApplySetupWhen } from "../enums";

export class ApplySetupWhenLookup {
    static getLookup() {
        return [
            { label: 'Daily', value: ApplySetupWhen.Daily },
            { label: 'Issue Invoice', value: ApplySetupWhen.IssueInvoice },
            { label: 'Finance Release', value: ApplySetupWhen.FinanceRelease },
        ];
    }

    static getTitle(value: number): string {
        switch (value) {
            case ApplySetupWhen.Daily:
                return 'Daily';
            case ApplySetupWhen.IssueInvoice:
                return 'Issue Invoice';
            case ApplySetupWhen.FinanceRelease:
                return 'Finance Release';
            default:
                return '';
        }
    }
}
